import React from 'react';
import { SvgIcon } from '@progress/kendo-react-common';
import { Button, ChipList, ChipProps } from '@progress/kendo-react-buttons';
import * as FilterSlice from '../../../../../../slices/FilterSlice';
import { useReduxDispatch, useReduxSelector } from '../../../../../../redux/hooks';
import * as svg from '@progress/kendo-svg-icons';
import { Link, useParams } from 'react-router-dom';
import { TicketApi } from '../../../../../../redux/api/TicketApi';

interface FilterBannerProps {
    filterDescription?: string;
    onCancel?: () => void;
}

const FilterBanner: React.FC<FilterBannerProps> = ({ filterDescription, onCancel }) => {
    const { ticketId } = useParams();
    const { data: actionTypes } = TicketApi.useGetTicketActionTypesQuery(parseInt(ticketId));
    const { data: staffList } = TicketApi.useGetTicketAuthorsQuery(parseInt(ticketId));
    const filterState = useReduxSelector(state => state.filter);
    const updateState = useReduxDispatch();

    const resetClicked = (e: any) => {
        updateState(FilterSlice.resetFilters());
    }

    const hasFilterApplied = Object.keys(filterState).some(key => {
        var areDifferent = filterState[key] !== FilterSlice.initialState[key]
        //if (areDifferent)
        //console.log('key', key, filterState[key], FilterSlice.initialState[key], filterState[key] === FilterSlice.initialState[key]);


        return areDifferent;
    });



    //Create the filter description
    let chips = [];
    let filterDescriptionString = '';
    if (filterState.authorIds.length > 0) {
        const selectedAuthors = staffList?.filter(at => filterState.authorIds.includes(at.ID)).map(at => at.Full_Name).join(', ')
        const filterCancelButton = <Button size='small' fillMode='flat' svgIcon={svg.xIcon} title='Clear filters' onClick={() => {
            updateState(FilterSlice.setAuthors(FilterSlice.initialState.authorIds))
            updateState(FilterSlice.setAuthorAndOr(FilterSlice.initialState.authorAndOr))
        }
        }></Button>
        chips.push({ text: <><Link className='nav-link d-inline-block' to='filter'>Authors: <b title={selectedAuthors}>{selectedAuthors}</b></Link> {filterCancelButton}</>, svgIcon: svg.userIcon });
        if (filterState.authorAndOr === 'or' && (filterState.actionTypeIds.length > 0 || filterState.dateRange || filterState.searchTerm !== '' || filterState.hasReactions)) {
            const filterCancelButton = <Button size='small' fillMode='flat' svgIcon={svg.xIcon} title='Clear filters' onClick={() => {
                updateState(FilterSlice.setAuthorAndOr(FilterSlice.initialState.authorAndOr))
            }}></Button>
            chips.push({ text: <><Link className='nav-link d-inline-block' to='filter'><b>Or</b></Link> {filterCancelButton}</> });
        }
    }
    if (filterState.actionTypeIds.length > 0) {
        const selectedActionTypes = actionTypes?.filter(at => filterState.actionTypeIds.includes(at.ID)).map(at => at.Action_Type).join(', ')
        const filterCancelButton = <Button size='small' fillMode='flat' svgIcon={svg.xIcon} title='Clear filters' onClick={() => {
            updateState(FilterSlice.setActionTypes(FilterSlice.initialState.actionTypeIds))
            updateState(FilterSlice.setActionTypeAndOr(FilterSlice.initialState.actionTypeAndOr))
        }}></Button>
        //filterDescriptionString += `${filterState.searchTermOption} Phrase: "${filterState.searchTerm}" `
        chips.push({ text: <><Link className='nav-link d-inline-block' to='filter'>Types: <b title={selectedActionTypes}>{selectedActionTypes}</b></Link> {filterCancelButton}</>, svgIcon: svg.categorizeIcon });
        if (filterState.actionTypeAndOr === 'or' && (filterState.dateRange || filterState.searchTerm !== '') || filterState.hasReactions) {
            const filterCancelButton = <Button size='small' fillMode='flat' svgIcon={svg.xIcon} title='Clear filters' onClick={() => updateState(FilterSlice.setActionTypeAndOr(FilterSlice.initialState.actionTypeAndOr))}></Button>
            chips.push({ text: <><Link className='nav-link d-inline-block' to='filter'><b>Or</b></Link> {filterCancelButton}</> });
        }
    }
    //date range
    if (filterState.dateRange) {
        const rangeString = filterState.dateRange === 'Custom' ? `${new Date(filterState.customStartDate).toDateString()} - ${new Date(filterState.customEndDate).toDateString()}` : filterState.dateRange;
        const filterCancelButton = <Button size='small' fillMode='flat' svgIcon={svg.xIcon} title='Clear filters' onClick={() => {
            updateState(FilterSlice.setDateRange(FilterSlice.initialState.dateRange))
            updateState(FilterSlice.setStartDate(FilterSlice.initialState.customStartDate))
            updateState(FilterSlice.setEndDate(FilterSlice.initialState.customEndDate))
        }
        }></Button>
        chips.push({ text: <><Link className='nav-link d-inline-block' to='filter'>Range: <b title={rangeString}>{rangeString}</b></Link> {filterCancelButton}</>, svgIcon: svg.calendarIcon });
    }
    //Text filter
    if (filterState.searchTerm !== '') {
        const filterCancelButton = <Button size='small' fillMode='flat' svgIcon={svg.xIcon} title='Clear filters' onClick={() => {
            updateState(FilterSlice.setSearchTerm(FilterSlice.initialState.searchTerm))
            updateState(FilterSlice.setSearchTermOption(FilterSlice.initialState.searchTermOption))
        }}></Button>
        //filterDescriptionString += `${filterState.searchTermOption} Phrase: "${filterState.searchTerm}" `
        chips.push({ text: <><Link className='nav-link d-inline-block' to='filter'>{filterState.searchTermOption}s: <b title={filterState.searchTerm}> {filterState.searchTerm}</b></Link> {filterCancelButton}</>, svgIcon: svg.textboxIcon });
    }
    //reations
    if (filterState.hasReactions) {
        //filterDescriptionString += `Range: ${filterState.dateRange}, `
        const filterCancelButton = <Button size='small' fillMode='flat' svgIcon={svg.xIcon} title='Clear filters' onClick={() => updateState(FilterSlice.setHasReaction(FilterSlice.initialState.hasReactions))}></Button>
        chips.push({ text: <><Link className='nav-link d-inline-block' to='filter'>Has Reactions: <b>yes</b></Link> {filterCancelButton}</>, svgIcon: svg.thumbUpIcon });
    }
    //no system actions
    if (filterState.showSystemActions === false) {
        //filterDescriptionString += `Range: ${filterState.dateRange}, `
        const filterCancelButton = <Button size='small' fillMode='flat' svgIcon={svg.xIcon} title='Clear filters' onClick={() => updateState(FilterSlice.setShowSystemActions(FilterSlice.initialState.showSystemActions))}></Button>
        chips.push({ text: <><Link className='nav-link d-inline-block' to='filter'>System actions: <b>no</b></Link> {filterCancelButton}</>, svgIcon: svg.gearsIcon });
    }

    if (!hasFilterApplied) return null;

    return (
        <div className="filter-banner">
            <div className='inline-block'>
                <div className='d-none'><SvgIcon icon={svg.filterIcon} style={{ marginRight: '2px' }} />Filters:</div>
                <ChipList data={chips} className='ms-2'></ChipList>
            </div>
            <Button size='small' fillMode='flat' svgIcon={svg.filterClearIcon} className='p-2' title='Clear all filters'
                onClick={resetClicked}                        >
            </Button>
        </div >
    );
};

export default FilterBanner;